import { SpacesProps } from "@/types/component.types";
import { ReactNode, CSSProperties } from "react";
import classNames from "classnames";

interface SectionWrapperProps {
  className?: string;
  id?: string;
  spaces?: SpacesProps[];
  children: ReactNode;
}

export default function SectionWrapper({
  className = "",
  id,
  spaces,
  children,
}: SectionWrapperProps) {

  const space = spaces?.[0];

  const dynamicStyles = {
    "--mt-xs": space?.top_xs !== "" && space?.top_xs !== undefined ? `${space.top_xs}px` : "0px",
    "--mt-md": space?.top_md !== "" && space?.top_md !== undefined ? `${space.top_md}px` : "0px",
    "--mt-xl": space?.top_xl !== "" && space?.top_xl !== undefined  ? `${space.top_xl}px` : "0px",
    "--mb-xs": space?.bottom_xs !== "" && space?.bottom_xs !== undefined ? `${space.bottom_xs}px` : "0px",
    "--mb-md": space?.bottom_md !== "" && space?.bottom_md !== undefined ? `${space.bottom_md}px` : "0px",
    "--mb-xl": space?.bottom_xl !== "" && space?.bottom_xl !== undefined ? `${space.bottom_xl}px` : "0px",
  } as CSSProperties;

  return (
    <section 
      id={id}
      style={dynamicStyles}
      className={classNames(
        space?.top_xs !== undefined && "mt-(--mt-xs)",
        space?.top_md !== undefined && "md:mt-(--mt-md)",
        space?.top_xl !== undefined && "xl:mt-(--mt-xl)",
        space?.bottom_xs !== undefined && "mb-(--mb-xs)",
        space?.bottom_md !== undefined && "md:mb-(--mb-md)",
        space?.bottom_xl !== undefined && "xl:mb-(--mb-xl)",
        className,
      )}
    >
      {children}
    </section>
  );
}